import * as actions from './actions';
import { DROPDOWN_DEFAULT_COUNTRY_LONG, PUBLISHED_COURSES } from '../../constants';

const initialState = {
    filteredCourses: [],
    filters: {
        search: '',
        country: DROPDOWN_DEFAULT_COUNTRY_LONG,
        status: '',
        year: ''
    },
    selectedProductId: 1,
    courses: [],
    genericCourses: []
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_DEFAULT_COURSES_REQUEST: {
        return {
            ...state,
            selectedProductId: action.productId,
            courses: [],
            filteredCourses: [],
            isLoaded: false,
            isLoading: true
        };
    }
    case actions.GET_DEFAULT_COURSES_SUCCESS: {
        const { courses } = action;
        const genericCourses = courses.filter(course => parseInt(course.status, 10) === PUBLISHED_COURSES);

        return {
            ...state,
            courses,
            genericCourses,
            isLoaded: true,
            isLoading: false
        };
    }
    case actions.GET_DEFAULT_COURSES_FAILURE: {
        return {
            ...state,
            isLoaded: false,
            isLoading: false
        };
    }
    case actions.APPLY_SEARCH_FILTER: {
        const updatedfilters = { ...state.filters };
        updatedfilters[action.label] = action.value;

        return {
            ...state,
            filters: updatedfilters
        };
    }
    case actions.RESET_SEARCH_FILTER: {
        return {
            ...state,
            filters: {
                ...state.filters,
                search: ''
            }
        };
    }
    case actions.FILTER_DEFAULT_COURSES: {
        return {
            ...state
        };
    }
    case actions.FILTER_DEFAULT_SUCCESS: {
        return {
            ...state,
            filteredCourses: action.filteredCourses
        };
    }
    case actions.ARCHIVE_SELECTED_COURSE_REQUEST: {
        return {
            ...state,
            isLoaded: false,
            isLoading: true
        };
    }
    case actions.ARCHIVE_SELECTED_COURSE_FAILURE: {
        return {
            ...state,
            isLoaded: false,
            isLoading: false
        };
    }
    default:
        return { ...state };
    }
}




// WEBPACK FOOTER //
// ./app/containers/default-courses/reducer.js